// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"176":"einkauf","535":"bestellungen","726":"registrierkasse"}[chunkId] + "." + {"176":"5ede2d1f","535":"ca0005c5","726":"e1d58678"}[chunkId] + ".css";
};